import { countActionTypes, SETDISPLAY } from '../../actions/simulationAdaptation/display'

const reducer = (state = 'AxialCurvature', action: countActionTypes): string => {
  switch (action.type) {
    case SETDISPLAY:
      return action.payload.n
    default:
      return state
  }
}

export default reducer
